import React, {FC} from "react";
import {IFormItem} from "../Types";
import {Form,TreeSelect} from "antd";
import { ITreeSelectData } from "../../YhPageHeader/Types";

export const __FormTreeSelect: FC<IFormItem> = (props) => {
    return (
        <Form.Item
            label={props.fieldLabel}
            name={props.fieldName}
            rules={props.rules}
            labelCol={props.labelCol}
        >
            <TreeSelect
                allowClear={props.allowClear}
                treeData={props.treeData}
                disabled={props.disable}
                onSelect={(value: string, option) => props.onTreeSelectChange?.(value, option as ITreeSelectData)}
            />
        </Form.Item>
    )
}